export const OPEN_ICCA_STATE = 'OPEN_ICCA_STATE';
export const ICCA_ID_STATE = 'ICCA_ID_STATE';

export const setIccaOpen = (state) => (dispatch) => {
    dispatch({ type: OPEN_ICCA_STATE, state });
};

export const setIccaId = (state) => (dispatch) => {
    dispatch({ type: ICCA_ID_STATE, state });
};

export default {
    OPEN_ICCA_STATE,
    setIccaOpen,
    ICCA_ID_STATE,
    setIccaId,
};
